import Content from '@/components/content/Content'
import ManageSection from '@/components/content/ManageSection'
import ManageTask from '@/components/content/ManageTask'
import ContentWrap from '@/components/content/ContentWrap'
import SectionWrap from '@/components/content/SectionWrap'
import TaskWrap from '@/components/content/TaskWrap'
import ContentList from '@/components/content/ContentList'
import CreateContent from '@/components/content/CreateContent'
import CreateSection from '@/components/content/CreateSection'
import CreateTask from '@/components/content/CreateTask'
import EditContent from '@/components/content/EditContent'

export default [
  {
    path: '/content',
    component: Content,
    children: [
      {path: '', component: ContentList},
      {path: 'create', component: CreateContent},
      {
        path: ':contentUrl',
        component: ContentWrap,
        children: [
          {path: '', component: EditContent},
          {path: 'create', component: CreateSection},
          {
            path: ':sectionUrl',
            component: SectionWrap,
            children: [
              {path: '', component: ManageSection},
              {path: 'create', component: CreateTask},
              {
                path: ':taskUrl',
                component: TaskWrap,
                children: [
                  {path: '', component: ManageTask}
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/content/routes.js